import { useState, useEffect, useRef, useCallback } from 'react';
import util from '@utils/utils';
import { LoadingDiv } from '@components/LoadingDiv';
import { Search, FileText, X, ArrowRight, MessageSquare, List, Plus, FileMinus, Minus, FilePlus, TrendingUp } from 'react-feather';
import ReactECharts from 'echarts-for-react';
import useCreateSearchFast from '@hooks/useCreateSearchFast';
import { ReactComponent as StatisticsSvg } from '@images/icons/statistics.svg';


const testdata = [
    {
        "from_organization": "自然资源部",
        "policy_theme": "地质灾害防治",
        "policy_time": "2022-10-27 14:18:00",
        "policy_class": "部门规章",
        "source_id": "84c75006-71f8-4466-8718-2ba662afd37a",
        "source_url": "https://www.gov.cn/zhengce/202310/content_6908641.htm",
        "state_grid_fields": [],
        "state_grid_keywords": [],
        "theme_list": [
            "地质灾害防治"
        ],
        "organization_list": [
            "自然资源部"
        ],
        "domain_list": [],
        "class_list": [
            "部门规章"
        ],
        "policy_title": "地质灾害防治单位资质管理办法"
    },
    {
        "from_organization": "中华人民共和国住房和城乡建设部 中华人民共和国交通运输部 中华人民共和国水利部 中华人民共和国人力资源和社会保障部",
        "policy_theme": "劳动、人事、监察\\劳动就业",
        "policy_time": "2020-02-28 00:00:00",
        "policy_class": "国务院部门文件",
        "source_id": "1b28237f-1804-4a0d-8776-ddbaa82b5cda",
        "source_url": "http://www.gov.cn/zhengce/zhengceku/2020-03/26/content_5495901.htm",
        "state_grid_fields": [],
        "state_grid_keywords": [],
        "theme_list": [
            "劳动",
            "人事",
            "监察",
            "劳动就业"
        ],
        "organization_list": [
            "中华人民共和国住房和城乡建设部",
            "中华人民共和国交通运输部",
            "中华人民共和国水利部",
            "中华人民共和国人力资源和社会保障部"
        ],
        "domain_list": [],
        "class_list": [
            "国务院部门文件"
        ],
        "policy_title": "住房和城乡建设部 交通运输部 水利部 人力资源社会保障部关于印发《监理工程师职业资格制度规定》《监理工程师职业资格考试实施办法》的通知"
    },
    {
        "from_organization": "住房城乡建设部 交通运输部 水利部 人力资源社会保障部",
        "policy_theme": "城乡建设、环境保护\\城乡建设（含住房）",
        "policy_time": "2018-07-20 00:00:00",
        "policy_class": "国务院部门文件",
        "source_id": "3fbf6ca1-9304-48ac-a46f-70bd8e8330ea",
        "source_url": "http://www.gov.cn/zhengce/zhengceku/2018-12/31/content_5433612.htm",
        "state_grid_fields": [],
        "state_grid_keywords": [],
        "theme_list": [
            "城乡建设",
            "环境保护",
            "城乡建设（含住房）"
        ],
        "organization_list": [
            "住房城乡建设部",
            "交通运输部",
            "水利部",
            "人力资源社会保障部"
        ],
        "domain_list": [],
        "class_list": [
            "国务院部门文件"
        ],
        "policy_title": "住房城乡建设部 交通运输部 水利部 人力资源社会保障部关于印发《造价工程师职业资格制度规定》《造价工程师职业资格考试实施办法》的通知"
    },
]
export const PolicyTrend = (props) => {
    const { pageSearchK } = props;
    const { loading, data, setQuery } = useCreateSearchFast({ manual: true });
    const [searchK, setSearchK] = useState()
    const [viewMode, setViewMode] = useState('yearly'); // 'yearly' or 'monthly'
    const [selectedTime, setSelectedTime] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedPolicy, setSelectedPolicy] = useState(data);
    const [option, setOption] = useState({});
    const [allTimes, setAllTimes] = useState([]);
    const [allDepartments, setAllDepartments] = useState([]);
    const [clickTime, setClickTime] = useState()
    const [wordCloudData, setWordCloudData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);


    useEffect(() => {
        if (pageSearchK) {
            setSearchK(pageSearchK)
        }
    }, [pageSearchK])
    useEffect(() => {
        if (searchK && isModalOpen) {
            setQuery({
                search_content: searchK,
                search_type: 'speed',
                page_size: 300,
                no_record: true,
            });
        }
    }, [searchK, isModalOpen]);
    useEffect(() => {
        if (data && data.length > 0) {
            setSelectedPolicy(data);
            const allTimeSet = new Set();
            const allDepartmentSet = new Set();
            data.forEach(item => {
                const year = item.policy_time.split('-')[0];
                const month = item.policy_time.split('-').slice(0, 2).join('-');
                allTimeSet.add(viewMode === 'yearly' ? year : month);
                allDepartmentSet.add(item.from_organization);
            });
            setAllTimes(Array.from(allTimeSet).sort());
            setAllDepartments(Array.from(allDepartmentSet).sort());

            // Set selectedTime and selectedDepartment to all available times and departments
            setSelectedTime(Array.from(allTimeSet).sort());
            setSelectedDepartment(Array.from(allDepartmentSet).sort());
        }
    }, [data, viewMode]);

    useEffect(() => {
        if (data && data.length > 0) {
            const filteredData = data.filter(item => {
                const time = viewMode === 'yearly' ? item.policy_time.split('-')[0] : item.policy_time.split('-').slice(0, 2).join('-');
                return (selectedTime.length === 0 || selectedTime.includes(time)) &&
                    (selectedDepartment.length === 0 || selectedDepartment.includes(item.from_organization));
            });

            if (filteredData.length === 0) {
                console.warn('filteredData is empty');
            }

            const timeMap = {};
            filteredData.forEach(item => {
                const time = viewMode === 'yearly' ? item.policy_time.split('-')[0] : item.policy_time.split('-').slice(0, 2).join('-');
                if (!timeMap[time]) timeMap[time] = 0;
                timeMap[time]++;
            });

            const sortedTimes = Object.keys(timeMap).sort();
            const seriesData = sortedTimes.map(time => timeMap[time]);

            // 找出陡然增加的年份
            const suddenIncreaseIndices = [];
            for (let i = 1; i < seriesData.length; i++) {
                if (seriesData[i] > 5 && (seriesData[i] / seriesData[i - 1] > 2)) {
                    suddenIncreaseIndices.push(i);
                }
            }

            const opt = {
                xAxis: {
                    type: 'category',
                    data: sortedTimes
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: seriesData,
                        type: 'line',
                        smooth: true, // 折线图使用曲线
                        symbolSize: (value, params) => {
                            if (suddenIncreaseIndices.includes(params.dataIndex)) {
                                return 12; // 陡然增加的年份节点加大
                            }
                            return 8;
                        },
                        itemStyle: {
                            color: (params) => {
                                if (suddenIncreaseIndices.includes(params.dataIndex)) {
                                    return 'red'; // 陡然增加的年份节点颜色变红
                                }
                                return '#5470c6';
                            }
                        }
                    }
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: (params) => {
                        const time = params[0].axisValue;
                        const policies = filteredData.filter(item => {
                            const itemTime = viewMode === 'yearly' ? item.policy_time.split('-')[0] : item.policy_time.split('-').slice(0, 2).join('-');
                            return itemTime === time;
                        });
                        const showPolicies = policies.slice(0, 3);
                        let policyNames = showPolicies.map(policy => `${policy.policy_title}<br/>`).join('');
                        if (policies.length > 3) {
                            policyNames += '...';
                        }
                        // Add the total number of policies
                        policyNames += `<br/>等 ${policies.length} 条政策`;
                        return policyNames;
                    }
                },
                // toolbox: {
                //     show: true,
                //     feature: {
                //         saveAsImage: {}
                //     }
                // }
            };
            setOption(opt);
        }
    }, [data, viewMode, selectedTime, selectedDepartment]);

    const handleChartClick = (params) => {
        const time = params.name;
        setClickTime(time)
        const filteredData = data.filter(item => {
            const itemTime = viewMode === 'yearly' ? item.policy_time.split('-')[0] : item.policy_time.split('-').slice(0, 2).join('-');
            return (selectedTime.length === 0 || selectedTime.includes(itemTime)) &&
                (selectedDepartment.length === 0 || selectedDepartment.includes(item.from_organization));
        });
        const policies = filteredData.filter(item => {
            const itemTime = viewMode === 'yearly' ? item.policy_time.split('-')[0] : item.policy_time.split('-').slice(0, 2).join('-');
            return itemTime === time;
        });
        setSelectedPolicy(policies);
    };

    const handleReset = () => {
        setViewMode('yearly');
        setSelectedTime([]);
        setSelectedDepartment([]);
        setClickTime()
        setSelectedPolicy(data)
    };

    // useEffect to generate word cloud data from selectedPolicy
    useEffect(() => {
        if (selectedPolicy && selectedPolicy.length > 0) {
            const themeFrequencyMap = {};
            selectedPolicy.forEach(policy => {
                policy.theme_list.forEach(theme => {
                    if (theme !== '其他') { // Filter out '其他'
                        if (themeFrequencyMap[theme]) {
                            themeFrequencyMap[theme]++;
                        } else {
                            themeFrequencyMap[theme] = 1;
                        }
                    }
                });
            });

            const wordCloudData = Object.keys(themeFrequencyMap).map(theme => ({
                name: theme,
                value: themeFrequencyMap[theme]
            }));

            setWordCloudData(wordCloudData);
        }
    }, [selectedPolicy]);
    // Function to get word cloud option
    const getWordCloudOption = () => {
        return {
            series: [
                {
                    type: 'wordCloud',
                    gridSize: 2,
                    sizeRange: [12, 50],
                    rotationRange: [-90, 90],
                    shape: 'pentagon',
                    textStyle: {
                        normal: {
                            color: function () {
                                return (
                                    'rgb(' +
                                    [
                                        Math.round(Math.random() * 255),
                                        Math.round(Math.random() * 255),
                                        Math.round(Math.random() * 255),
                                    ].join(',') +
                                    ')'
                                );
                            },
                        },
                        emphasis: {
                            shadowBlur: 10,
                            shadowColor: '#333',
                        },
                    },
                    data: wordCloudData,
                    tooltip: {
                        show: true,
                        formatter: function (params) {
                            return `${params.name} : ${params.value}`;
                        },
                    },
                },
            ],
        };
    };
    const handleWordCloudClick = (params) => {
        const selectedTheme = params.name;
        console.log(`Clicked on theme: ${selectedTheme}`);
        setSearchK(selectedTheme)
        // You can add additional logic here, such as filtering policies by the selected theme
    };
    const closeModalReset = () => {
        handleReset();
        setSearchK(pageSearchK);
        setIsModalOpen(false);
    }

    return (
        <>
            <button
                id="fastCompareBtn"
                className={`h-4 bg-base-100 group btn shadow-lg hover:btn-primary hover:text-white`}
                onClick={() => {
                    setIsModalOpen(true);
                    document.getElementById('my_policy_trend_modal').showModal();
                }}
            >
                <TrendingUp size="1.5rem" />
                <span className='group-hover:block hidden'>政策趋势</span>
            </button>
            <dialog id="my_policy_trend_modal" className="modal" onClose={() => setIsModalOpen(false)}>
                <div className="flex flex-col modal-box p-0 relative w-[90vw] h-[90vh] max-w-[90vw]">
                    <div className="bg-white p-4 sticky top-0 z-10">
                        <div className="flex justify-between items-center">
                            {searchK && <h2 className="card-title pl-4 mr-6">【政策趋势】- {searchK}</h2>}
                            <form method="dialog">
                                <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 m-1" onClick={()=>closeModalReset()}>✕</button>
                            </form>
                        </div>
                    </div>

                    <div className="flex-1 overflow-auto p-2 lg:px-16 lg:py-4 text-justify">
                        <div className='flex w-full items-center gap-4 mb-2'>

                            <div className="card-title ">
                                <TrendingUp />
                                政策曲线
                            </div>
                            {/* <div className='text-secondary'>
                                讲话报告内容聚类分析
                            </div> */}
                        </div>
                        {
                            loading ? <LoadingDiv /> :
                            <>
                            {
                                data?.length > 0 ? 
                                <div className='h-[38vh]'>
                                    <div className="flex gap-4 items-center p-4">
                                        <div className="join">
                                            <button
                                                className={`btn join-item btn-sm ${viewMode === 'yearly' ? 'btn-active' : ''}`}
                                                onClick={() => setViewMode('yearly')}
                                            >
                                                按年查看
                                            </button>
                                            <button
                                                className={`btn join-item btn-sm ${viewMode === 'monthly' ? 'btn-active' : ''}`}
                                                onClick={() => setViewMode('monthly')}
                                            >
                                                按月查看
                                            </button>
                                        </div>
                                        <div className="dropdown dropdown-bottom">
                                            <label tabIndex={0} className="btn btn-sm">
                                                时间筛选
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </label>
                                            <ul tabIndex={0} className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 z-20 overflow-auto max-h-[50vh] block">
                                                <li>
                                                    <label className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedTime.length === allTimes.length}
                                                            onChange={() => {
                                                                if (selectedTime.length === allTimes.length) {
                                                                    setSelectedTime([]);
                                                                } else {
                                                                    setSelectedTime([...allTimes]);
                                                                }
                                                            }}
                                                            className="checkbox"
                                                        />
                                                        全选
                                                    </label>
                                                </li>
                                                {allTimes.map(time => (
                                                    <li key={time}>
                                                        <label className="flex items-center">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedTime.includes(time)}
                                                                onChange={() => {
                                                                    if (selectedTime.includes(time)) {
                                                                        setSelectedTime(selectedTime.filter(t => t !== time));
                                                                    } else {
                                                                        setSelectedTime([...selectedTime, time]);
                                                                    }
                                                                }}
                                                                className="checkbox"
                                                            />
                                                            {time}
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="dropdown dropdown-bottom">
                                            <label tabIndex={0} className="btn btn-sm">
                                                部门筛选
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </label>
                                            <ul tabIndex={0} className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 z-20 overflow-auto max-h-[50vh] block">
                                                <li>
                                                    <label className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDepartment.length === allDepartments.length}
                                                            onChange={() => {
                                                                if (selectedDepartment.length === allDepartments.length) {
                                                                    setSelectedDepartment([]);
                                                                } else {
                                                                    setSelectedDepartment([...allDepartments]);
                                                                }
                                                            }}
                                                            className="checkbox"
                                                        />
                                                        全选
                                                    </label>
                                                </li>
                                                {allDepartments.map(department => (
                                                    <li key={department}>
                                                        <label className="flex items-center">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedDepartment.includes(department)}
                                                                onChange={() => {
                                                                    if (selectedDepartment.includes(department)) {
                                                                        setSelectedDepartment(selectedDepartment.filter(d => d !== department));
                                                                    } else {
                                                                        setSelectedDepartment([...selectedDepartment, department]);
                                                                    }
                                                                }}
                                                                className="checkbox"
                                                            />
                                                            {department}
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <button className="btn btn-sm" onClick={handleReset}>
                                            重置筛选
                                        </button>
                                    </div>

                                    <ReactECharts
                                        style={{ height: '100%' }}
                                        option={option}
                                        onEvents={{
                                            click: handleChartClick
                                        }}
                                    />
                                </div> :
                                                                                    <div className="w-full text-center p-4">
                                                                                    暂无内容
                                                                                </div>
                            
                            }
                            </>
                        }
                        <div className='grid grid-cols-2 gap-8'>
                            <div className="space-y-2 mt-12">
                                <div className='flex w-full items-center gap-4 mb-6'>
                                    <StatisticsSvg size='1.5rem' />
                                    <div className="card-title">
                                        热点分布  {clickTime ? `- ${clickTime}` : ''}
                                    </div>
                                </div>
                                <div className='max-h-[30vh] overflow-y-auto space-y-2 pr-4'>
                                    {
                                        loading ? <LoadingDiv /> :
                                            <>
                                                {wordCloudData.length > 0 ? (
                                                    <ReactECharts
                                                        style={{ height: '30vh' }}
                                                        option={getWordCloudOption()}
                                                        onEvents={{
                                                            click: handleWordCloudClick // Add click event handler
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="w-full text-center p-4">
                                                        暂无内容
                                                    </div>
                                                )}
                                            </>}
                                </div>
                            </div>
                            <div className="space-y-2 mt-12">
                                <div className='flex w-full items-center gap-4 mb-6'>
                                    <List size="1.5rem" />
                                    <div className="card-title">
                                        政策列表  {clickTime ? `- ${clickTime}` : ''}
                                    </div>
                                </div>
                                <div className='max-h-[30vh] overflow-y-auto space-y-2 pr-4'>
                                    {
                                        loading ? <LoadingDiv /> :
                                            <>
                                                {selectedPolicy?.length > 0 ?
                                                    <>
                                                        {selectedPolicy.map((policy, index) => (
                                                            <div
                                                                key={policy.source_id}
                                                                className={`flex items-center justify-between py-3 px-6 rounded-lg transition-all duration-200 bg-gray-50 hover:bg-gray-100
                                                    }`}
                                                            >
                                                                <div className='flex-1'>
                                                                    <div className='text-lg font-bold cursor-pointer hover:text-primary'
                                                                        onClick={(e) => {
                                                                            e.preventDefault(); e.stopPropagation();
                                                                            window.open(util.buildPolicyFileUrl(policy?.policy_title, policy?.source_id, '', window.location.href), '_blank')
                                                                        }}>
                                                                        {index + 1}. {policy?.policy_title}
                                                                    </div>
                                                                    <div className='text-secondary flex gap-2'>
                                                                        <span>[{policy.large_policy_class}]</span>
                                                                        <span>政策来源：{policy?.from_organization?.replaceAll(/:/g, "")}</span>
                                                                        <span>{util.dateTransformToCN(policy?.policy_time)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                    :
                                                    <div className="w-full text-center p-4">
                                                        暂无内容
                                                    </div>

                                                }
                                            </>}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button onClick={()=>closeModalReset()}>close</button>
                </form>
            </dialog>
        </>
    );
}